import { Action } from 'redux';

import { GetExtractEncryptionKeyRequest, GetExtractEncryptionKeyRequestSucceeded } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';

import { IGetSiteEncryptionKeyResult } from '../models/ExtractEncryptionModels';

export interface GetExtractEncryptionKeyRequestAction extends Action {}

export function getExtractEncryptionKeyRequest(): GetExtractEncryptionKeyRequestAction {
  return {
    type: GetExtractEncryptionKeyRequest
  };
}

export const isGetExtractEncryptionKeyRequest = isActionFactory<GetExtractEncryptionKeyRequestAction>(GetExtractEncryptionKeyRequest);

export interface GetExtractEncryptionKeyRequestSucceededAction extends Action {
    readonly encryptionKey: IGetSiteEncryptionKeyResult;
  }

  export function getExtractEncryptionKeyRequestSucceeded(encryptionKey: IGetSiteEncryptionKeyResult): GetExtractEncryptionKeyRequestSucceededAction {
    return {
      type: GetExtractEncryptionKeyRequestSucceeded,
      encryptionKey
    };
  }

  export const isGetExtractEncryptionKeyRequestSucceeded = isActionFactory<GetExtractEncryptionKeyRequestSucceededAction>(GetExtractEncryptionKeyRequestSucceeded);